import "core-js/modules/es.object.to-string.js";
import { getIsAssetEditableInHub } from 'utils/privileges/getIsAssetEditableInHub';
import { getIsPlaylistEditable } from 'utils/privileges/getIsPlaylistEditable';
import config from 'utils/config';
import { hasPrivilege, isTeamManager } from 'utils/privileges';
export function checkIsItemEditable(_ref) {
  var item = _ref.item,
    isParentPlaylistDistributed = _ref.isParentPlaylistDistributed,
    parentPlaylistMemberContributions = _ref.parentPlaylistMemberContributions,
    parentPlaylistOwnerTeamId = _ref.parentPlaylistOwnerTeamId;
  var hasMemberContributionsEnabled = parentPlaylistMemberContributions && config.memberContributions;
  if (item.type === 'playlist') {
    return getIsPlaylistEditable({
      playlist: item,
      allowEditingDistributedPlaylists: true
    });
  } else if (item.type === 'section') {
    return !isParentPlaylistDistributed && !!(hasPrivilege('playlist_write') || parentPlaylistOwnerTeamId && isTeamManager(parentPlaylistOwnerTeamId));
  } else {
    var _item$author;
    // asset check
    return getIsAssetEditableInHub({
      ownerTeamId: item.ownerTeamId,
      domain_id: item.domain_id,
      allowEditingDistributedPlaylists: true,
      authorId: hasMemberContributionsEnabled && ((_item$author = item.author) === null || _item$author === void 0 ? void 0 : _item$author.id)
    });
  }
}
export function checkIsSelectionEditable(_ref2) {
  var items = _ref2.items,
    parentPlaylistMemberContributions = _ref2.parentPlaylistMemberContributions;
  var hasMemberContributionsEnabled = parentPlaylistMemberContributions && config.memberContributions;
  if (items.some(function (item) {
    return item.type === 'playlist';
  }) || items.some(function (item) {
    return item.type === 'section';
  })) {
    return false;
  }
  return items.every(function (item) {
    var _item$author2;
    if (item.type === 'playlist' || item.type === 'section') {
      return false;
    }
    return getIsAssetEditableInHub({
      ownerTeamId: item.ownerTeamId,
      domain_id: item.domain_id,
      allowEditingDistributedPlaylists: true,
      authorId: hasMemberContributionsEnabled && ((_item$author2 = item.author) === null || _item$author2 === void 0 ? void 0 : _item$author2.id)
    });
  });
}